/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { OfferApiConfiguration } from '../offer-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PomValidatePartnerRequestDto } from '../models/pom-validate-partner-request-dto';
import { ResultDetailsDto } from '../models/result-details-dto';


/**
 * the Validate offer API
 */
@Injectable({
  providedIn: 'root',
})
export class ValidateOfferService extends BaseService {
  constructor(
    config: OfferApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation validate
   */
  static readonly ValidatePath = '/validate-partner';

  /**
   * Validate partnerCode, employeeCode and productCode
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `validate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  validate$Response(params: {
    body: PomValidatePartnerRequestDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ResultDetailsDto>> {

    const rb = new RequestBuilder(this.rootUrl, ValidateOfferService.ValidatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResultDetailsDto>;
      })
    );
  }

  /**
   * Validate partnerCode, employeeCode and productCode
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `validate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  validate(params: {
    body: PomValidatePartnerRequestDto
  },
  context?: HttpContext

): Observable<ResultDetailsDto> {

    return this.validate$Response(params,context).pipe(
      map((r: StrictHttpResponse<ResultDetailsDto>) => r.body as ResultDetailsDto)
    );
  }

}
